import React from 'react';

import { ColorScheme } from '~/design-tokens/themes/themes';

import styles from './InvertedThresholdArea.module.scss';
import { Variant } from '../../utils';

const colors: Record<Variant, string> = {
  positive: 'var(--viz-bullish)',
  negative: 'var(--viz-bearish)',
  neutral: 'var(--viz-neutral)',
};

const softColors: Record<Variant, string> = {
  positive: 'var(--viz-bullish-soft)',
  negative: 'var(--viz-bearish-soft)',
  neutral: 'var(--viz-neutral-soft)',
};

interface InvertedThresholdAreaProps {
  variant?: Variant;
  offset?: number;
  width?: string | number;
  edgeOffset?: number;
  colorScheme?: ColorScheme;
}

export const InvertedThresholdArea = ({
  variant = 'positive',
  width,
  offset,
  edgeOffset = offset,
  colorScheme,
}: InvertedThresholdAreaProps) => {
  return (
    <g>
      <rect
        className={styles.areaRectBackground}
        data-testid="color-area-rectangle"
        width={width}
        x={offset}
        height="100%"
        style={{ fill: softColors[variant] }}
      />
      {edgeOffset &&
        (variant === 'negative' ? (
          <line
            className={styles.edgeLine}
            data-testid="negative-edge-line"
            y1="0"
            x1={edgeOffset}
            y2="100%"
            x2={edgeOffset}
            style={{ stroke: colors[variant] }}
          />
        ) : (
          <line
            className={styles.lineAxis}
            data-testid="positive-edge-line"
            y1="0"
            x1={edgeOffset}
            y2="100%"
            x2={edgeOffset}
            style={{ stroke: colors[variant] }}
          />
        ))}
      <rect
        className={styles.lineColorBlendMask}
        width={width}
        x={offset}
        height="100%"
        style={{
          fill: colors[variant],
          mixBlendMode:
            colorScheme === ColorScheme.Light ? 'lighten' : 'darken',
        }}
      />
    </g>
  );
};
